module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "30",
      "tablet": "40"
    }
  }, [_c('mu-card', {
    nativeOn: {
      "click": function($event) {
        return _vm.toggleFilterShowing.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_vm._v("\n          Refine filters\n          "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('mu-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.refiningFilters === true),
      expression: "refiningFilters === true"
    }],
    attrs: {
      "value": "keyboard_arrow_up"
    }
  }), _vm._v(" "), _c('mu-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.refiningFilters === false),
      expression: "refiningFilters === false"
    }],
    attrs: {
      "value": "keyboard_arrow_down"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.refiningFilters === true) ? _c('div', [_c('recipe-search', {
    attrs: {
      "is-results-page": true,
      "fullWidth": true,
      "filterData": _vm.filterData,
      "categories": _vm.$store.state.recipes.categories
    },
    on: {
      "filterModel": _vm.onFilterModelChange,
      "recipeData": _vm.onRecipeSearchLoaded,
      "isSearching": _vm.onSearchInitiated
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "60"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "height": "500px",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('mu-circular-progress'), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('message.loadingText')) + "\n        ")], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.recipeData) ? _c('div', [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.recipeData.recipes), function(item, recipeI) {
    return _c('mu-col', {
      key: 'recipe-' + recipeI,
      staticClass: "bottom",
      attrs: {
        "width": "100",
        "desktop": "33",
        "tablet": "50"
      }
    }, [(item) ? _c('div', [_c('recipe-card', {
      attrs: {
        "recipe": item
      }
    })], 1) : _vm._e()])
  }), 1), _vm._v(" "), (_vm.recipeData) ? _c('mu-pagination', {
    attrs: {
      "total": _vm.recipeData.paginationInfo.totalItems,
      "current": _vm.recipeData.paginationInfo.actualPage + 1,
      "defaultPageSize": 15,
      "pageSize": 15
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fc992b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/Results.vue
// module id = 3720
// module chunks = 1